import { render } from "./ImageSlideshowOverlay.vue?vue&type=template&id=576a0132&scoped=true"
import script from "./ImageSlideshowOverlay.vue?vue&type=script&lang=js"
export * from "./ImageSlideshowOverlay.vue?vue&type=script&lang=js"

import "./ImageSlideshowOverlay.vue?vue&type=style&index=0&id=576a0132&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576a0132"]])

export default __exports__